import React, { useEffect, useState } from "react";
import { baseUrl } from "../../constants/strapi-base-url.constant.ts";
import { fetchLocalizedCollection } from "../../constants/cms-locale.constant.ts";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import classes from "./Author.module.scss";
import { useParams } from "react-router-dom";
import noise from "../../media/noise.png";
import ClipLoader from "react-spinners/ClipLoader";
import facebookIcon from "../../media/footer/facebook.svg";
import instagramIcon from "../../media/footer/instagram.svg";


const Author = () => {
  const [loading, setLoading] = useState(false);
  const [blogPreviews, setBlogPreviews] = useState([]);
  const [author, setAuthor] = useState<{
    name: string;
    description: string | null;
    instagramLink: string | null;
    facebookLink: string | null;
    avatar: string | null;
  } | null>(null);

  const { id } = useParams();
  const { t, i18n } = useTranslation();

  const getAuthor = async () => {
    setLoading(true);


    await fetchLocalizedCollection(
         `blogs?pagination[pageSize]=100&populate[0]=full_info&populate[1]=full_info.blog_author&populate[2]=full_info.image_block&populate[3]=full_info.video_block&populate[4]=full_info.video_block.text_block_1&populate[5]=full_info.video_block.text_block_2&populate[6]=full_info.video_block.video&populate[7]=full_info.image_block.image&populate[8]=full_info.blog_author.blog_author.Avatar&populate[9]=full_info.cta_block&populate[10]=blog_preview&populate[11]=blog_preview.image`,
         i18n.language,
      )
      .then((allBlogs) => {
          const blogs = allBlogs.filter(d => d.full_info?.blog_author?.documentId === id);
        setBlogPreviews(
            blogs.map((blog) => ({
            id: blog.slug ?? blog.documentId,
            text: blog.blog_preview?.text,
            title: blog.blog_preview?.title,
            image: blog.blog_preview?.image
              ? `${baseUrl}${blog.blog_preview.image.url}`
              : null,
          })),
        );
        setLoading(false);
        const blog = blogs[0].full_info;
        setAuthor({
          name: blog.blog_author.blog_author.Name,
          description: blog.blog_author.blog_author.description ?? null,
          facebookLink: blog.blog_author.blog_author.facebook_link ?? null,
          instagramLink: blog.blog_author.blog_author.instagram_link ?? null,
          avatar: blog.blog_author.blog_author.Avatar
            ? `${baseUrl}${blog.blog_author.blog_author.Avatar.url}`
            : null,
        });
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    getAuthor();
  }, [id, i18n.language]);

  if (loading) {
    return (
      <main id="nav-dark" className={classes["loading-container"]}>
        <ClipLoader size={120} color="#182347" />
      </main>
    );
  }

  return (
    <main>
      <section className={classes["heading-container"]} id="nav-dark">
        <div className={`${classes["circle"]} ${classes["circle--4"]}`}></div>
        <div className={`${classes["circle"]} ${classes["circle--3"]}`}></div>
        <div className={`${classes["circle"]} ${classes["circle--2"]}`}></div>
        <div className={`${classes["circle"]} ${classes["circle--1"]}`}></div>
        <img
          src={noise}
          alt={"noise background"}
          className={classes["noise"]}
        />
        {author && (
          <div className={classes.container}>
            <div className={classes.path}>
              <Link to="/">{t("blog.breadcrumbHome")}</Link> /{" "}
              <Link to="/blogs">{t("blog.breadcrumbBlog")}</Link> /{" "}
              {t("blog.author")} {author.name}
            </div>
            <div className={classes["author-info"]}>
              {author.avatar && (
                <img
                  src={author.avatar}
                  alt="Avatar"
                  className={classes.avatar}
                />
              )}
              <div className={classes["text-container"]}>
                {author.name && <h4 className={classes.name}>{author.name}</h4>}

                <div className={classes["links-block"]}>
                  {author.instagramLink && (
                    <Link target="_blank" to={author.instagramLink}>
                      <img alt="Instagram icon" src={instagramIcon} />
                    </Link>
                  )}
                  {author.facebookLink && (
                    <Link target="_blank" to={author.facebookLink}>
                      <img alt="Facebook icon" src={facebookIcon} />
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </section>

      <section className="section--white" id="nav-dark">
        <div className={classes.container}>
          <h2 className={classes.title}>{t("blog.authorArticles")}</h2>

          <div className={classes["blogs-list"]}>
            {blogPreviews.map((blog) => (
              <Link key={blog.id}
                to={`/blogs/${blog.id.toString()}`}
                className={classes["blog-link"]}
              >
                <div className={classes.blog} key={blog.id}>
                  {blog.image && <img src={blog.image} alt={blog.title} />}
                  <div className={classes["text-container"]}>
                    <h3 className={classes["blog-title"]}>{blog.title}</h3>
                    <p className={classes["blog-text"]}>{blog.text}</p>

                    <span className={classes["created-at"]}>
                      {blog.addedAt}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default Author;
